export default __webpack_public_path__ + "static/media/MultiCopy-dark.822fd5ee.svg";